import React from 'react';
import { urunleriSirala } from './urunSiralama';

// Para formatlama için yardımcı fonksiyon
const formatCurrency = (value) => {
    return `${(value || 0).toFixed(2)} ₺`;
};

// Ödeme Yöntemi kodlarını okunabilir metne çeviren harita
const odemeYontemiMap = {
    K: 'Kapıda Ödeme',
    E: 'EFT / Havale',
    O: 'Online Ödeme',
    D: 'Kurum Ödemesi',
    B: 'Ücretsiz Gönderi'
};


function ProformaPreview({ detayData, isForDownload, ekLabel }) {

    // Stil tanımlamaları (Değişiklik yok)
    const styles = {
        container: {
            width: '375px',
            height: isForDownload ? 'auto' : '650px', // Telefon ekranı oranına uygun sabit yükseklik
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            padding: '20px',
            fontFamily: '"Poppins", sans-serif', // Ana font Poppins olarak ayarlandı
            backgroundColor: '#ffffff',
            color: '#333',
            fontSize: '13px', // Genel font boyutu
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            display: 'flex',
            flexDirection: 'column', // İçeriği dikeyde yönetmek için
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            borderBottom: '1px solid #eee',
            paddingBottom: '15px',
            marginBottom: '0px'
        },
        userInfo: {
            maxWidth: '65%'
        },
        dateInfo: {
            textAlign: 'right',
            fontSize: '12px'
        },
        tableContainer: {
            flex: 1, // Bu alanın kalan boşluğu doldurmasını sağlar
            margin: '10px 0',
            overflowY: isForDownload ? 'visible' : 'auto',
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            marginBottom: '30px'
        },
        th: {
            textAlign: 'left',
            padding: '4px',
            borderBottom: '1px solid #ddd',
            backgroundColor: '#f9f9f9',
            fontSize: '12px',
            textTransform: 'uppercase'
        },
        td: {
            textAlign: 'left',
            padding: '8px',
            borderBottom: '1px solid #f2f2f2',
            fontSize: '11px'
        },
        footer: {
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '20px',
            paddingTop: '20px',
            borderTop: 'auto'
        },
        totals: {
            width: '230px', // Toplamlar bölümünü sola kaydırmak için genişlik ayarı'
        },
        totalRow: {
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '5px'
        },
        totalLabel: {
            // İki noktaların hizalanması için etiketlere sabit genişlik veriyoruz
            display: 'inline-block',
            width: '120px', 
            textAlign: 'left',
            marginRight: '10px'
        },    
        grandTotalLabel: {
            fontWeight: 'bold',
            fontSize: '16px', // Genel Toplam font boyutu
            color: '#000'
        },
        grandTotalValue: {
            fontWeight: 'bold',
            fontSize: '16px',
        },
        paymentTypeContainer: {
            fontWeight: 'bold'
        },
        paymentTypeValue: {
            fontSize: '16px', // Ödeme türü font boyutu
            color: 'red',     // Ödeme türü rengi
            marginTop: '10px'
        }
    };

    // --- DEĞİŞİKLİK BURADA: Backend'den gelen doğru yapıya göre verileri alıyoruz ---
    const {
        musteri = {}, // Müşteri verisi artık 'musteri' objesinin içinde, yoksa boş obje kullan
        sepet: urunler = [], // 'sepet' dizisini 'urunler' olarak yeniden adlandırıyoruz
        siparis_tarihi,
        teklif_tarihi,  // Teklifler için tarih alanı
        tarih,  // Liste görünümünden gelen tarih
        kargo_ucreti,
        kapida_odeme_ucreti,
        indirim,
        kdv_tutari,
        toplam_bedel,
        odeme_yontemi,
        siparis_kaynagi, // Sipariş kaynağı: 'M' = Manuel, 'S' = Site (CSV)
        teklif_kaynagi   // Teklif kaynağı
    } = detayData;

    const mainUrunler = (urunler || []).map((urun) => ({
        ...urun,
        isEk: Boolean(urun.isEk || urun.source_ek_id)
    }));
    
    // Ürünleri sırala: Özel Baskı, Metrelik, Esmaül Hüsna, Büyük Ebat, Makine, Yan Ürünler (grup içinde DB sırası)
    const siraliUrunler = urunleriSirala(mainUrunler);
    
    // NULL değerleri 0 ile değiştir
    const safeKargoUcreti = kargo_ucreti || 0;
    const safeKapidaOdemeUcreti = kapida_odeme_ucreti || 0;
    const safeIndirim = indirim || 0;
    const safeKdvTutari = kdv_tutari || 0;
    const safeToplam = toplam_bedel || 0;
    
    // Tarihi formatlayalım (sipariş_tarihi, teklif_tarihi veya tarih alanlarından birini kullan)
    const displayDate = siparis_tarihi || teklif_tarihi || tarih;
    const formattedDate = displayDate ? new Date(displayDate).toLocaleDateString('tr-TR') : 'Belirtilmemiş';

    const isAltSiparis = detayData.isAltSiparis || false;

    return (
        <div style={styles.container} id={`proforma-${detayData.id}`}>
            {/* Üst Kısım: Alıcı ve Tarih Bilgileri (musteri objesinden okunacak şekilde düzeltildi) */}
            <div style={styles.header}>
                <div style={styles.userInfo}>
                    <div style={{fontWeight: 'bold', marginBottom: '5px'}}>{musteri.ad_soyad}</div>
                    <div>{musteri.telefon_numarasi}</div>
                    <div style={{fontSize: '10px', color: '#666', marginTop: '5px'}}>{`${musteri.adres} ${musteri.ilce} / ${musteri.il}`}</div>
                </div>
                <div style={styles.dateInfo}>
                    <strong>{siparis_tarihi ? 'Sipariş Tarihi' : 'Teklif Tarihi'}</strong>
                    <div>{formattedDate}</div>
                </div>
            </div>
            <div style={styles.paymentTypeContainer}>
                <div style={{...styles.paymentTypeValue, display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <span>
                        {isAltSiparis
                            ? 'ALT SİPARİŞ'
                            : siparis_tarihi 
                                ? `${odemeYontemiMap[odeme_yontemi] || 'Belirtilmemiş'}`
                                : `TEKLİFTİR (${odemeYontemiMap[odeme_yontemi] || 'Belirtilmemiş'})`
                        }
                    </span>
                    {ekLabel && (
                        <span style={{ color: '#1565C0', fontWeight: 'bold', fontSize: '14px' }}>
                            {ekLabel}
                        </span>
                    )}
                </div>
            </div>

            {/* Orta Kısım: Ürün Listesi (birim_fiyat -> fiyat olarak düzeltildi) */}
            <div 
                id={`proforma-table-container-${detayData.id}`}
                style={styles.tableContainer}>
                <table style={styles.table}>
                <thead>
                    <tr>
                        <th style={styles.th}>Ürün Adı</th>
                        <th style={{...styles.th, textAlign: 'center'}}>Birim Fiyat</th>
                        <th style={{...styles.th, textAlign: 'center'}}>Adet</th>
                        <th style={{...styles.th, textAlign: 'right'}}>Toplam</th>
                    </tr>
                </thead>
                <tbody>
                    {siraliUrunler.map((urun, index) => {
                        // B ödeme yöntemi (Ücretsiz Gönderi) için fiyatlar 0 TL gösterilir
                        const birimFiyat = odeme_yontemi === 'B' ? 0 : urun.fiyat;
                        const toplamFiyat = odeme_yontemi === 'B' ? 0 : (urun.fiyat * urun.adet);
                        const isEkUrun = Boolean(urun.isEk);
                        
                        return (
                            <tr key={`${urun.ekLabel || 'ana'}-${index}-${urun.urun_adi}`}>
                                <td style={{ ...styles.td, color: isEkUrun ? '#1565C0' : '#333', fontWeight: isEkUrun ? '600' : '400' }}>
                                    {urun.urun_adi}
                                </td>
                                <td style={{...styles.td, textAlign: 'center', color: isEkUrun ? '#1565C0' : '#333'}}>{formatCurrency(birimFiyat)}</td>
                                <td style={{...styles.td, textAlign: 'center', color: isEkUrun ? '#1565C0' : '#333'}}>{urun.adet}</td>
                                <td style={{...styles.td, textAlign: 'right', fontWeight: '500', color: isEkUrun ? '#1565C0' : '#333'}}>{formatCurrency(toplamFiyat)}</td>
                            </tr>
                        );
                    })}
                </tbody>
                </table>
            </div>            
            {/* Alt Kısım: Toplamlar ve Ödeme Türü (alan adları düzeltildi) */}
                <div style={styles.footer}>
                            <div style={styles.totals}>
                                {!isAltSiparis && (
                                    <div style={styles.totalRow}>
                                        <span style={styles.totalLabel}>Kargo Ücreti</span>
                                        <span>{formatCurrency(safeKargoUcreti)}</span>
                                    </div>
                                )}
                                {!isAltSiparis && safeKapidaOdemeUcreti > 0 && (
                                    <div style={styles.totalRow}>
                                        <span style={styles.totalLabel}>Kapıda Ödeme</span>
                                        <span>{formatCurrency(safeKapidaOdemeUcreti)}</span>
                                    </div>
                                )}
                                {safeIndirim !== 0 && (
                                    <div style={styles.totalRow}>
                                        <span style={styles.totalLabel}>İndirim / Ek Bedel</span>
                                        <span>{formatCurrency(safeIndirim)}</span>
                                    </div>
                                )}
                                {!isAltSiparis && (
                                    <div style={styles.totalRow}>
                                        <span style={styles.totalLabel}>KDV</span>
                                        <span>{safeKdvTutari > 0 ? formatCurrency(safeKdvTutari) : '(Dahil)'}</span>
                                    </div>
                                )}
                                <div style={{ ...styles.totalRow, ...styles.grandTotalLabel, marginTop: '10px' }}>
                                    <span style={styles.totalLabel}>GENEL TOPLAM</span>
                                    <span style={styles.grandTotalValue}>{formatCurrency(safeToplam)}</span>
                                </div>
                            </div>
                        </div>

                        {/* Özel Baskı Uyarısı */}
                        {siraliUrunler.some(urun => urun.urun_tipi === 'Özel Baskı') && (
                            <div style={{ marginTop: '15px', paddingTop: '10px', borderTop: '1px solid #eee', color: '#d9534f', fontWeight: 'bold', fontStyle: 'italic', textAlign: 'center', fontSize: '12px' }}>
                                * Siparişinizde Özel Baskı bulunmaktadır. 4-5 iş günü içerisinde kargoya verilecektir.
                            </div>
                        )}
                    </div>
    );
}

export default ProformaPreview;